/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import { takeEvery, call, put, all, takeLatest } from "redux-saga/effects";

import * as types from "../config/actionType";
import * as service from "../services/paramUserService";
import * as actions from "../action/paramUserAction";

function* loadParamUser(data) {
  try {
    yield put(actions.loadParamUserRequestAction());
    const param = yield call(service.getListParamForUserPerVehicule, data);
    // console.log("resloadparam = ", param)
    yield put(actions.loadedParamAction(param));
  } catch (error) {
    yield put(actions.loadParamUserErrorAction(error));
  } finally {
    yield put(actions.loadParamUserFinishAction());
  }
}

function* loadParamForCurrentUser(data) {
  try {
    yield put(actions.loadParamUserRequestAction());
    const param = yield call(service.getListParamForCurrentUserPerVehicule);
    // console.log("resloadparam = ", param)
    yield put(actions.loadedParamAction(param));
  } catch (error) {
    yield put(actions.loadParamUserErrorAction(error));
  } finally {
    yield put(actions.loadParamUserFinishAction());
  }
}

function* updateParamUser(data) {
  try {
    yield console.log("data = ", param);
    yield put(actions.loadParamUserRequestAction());
    const perm = yield call(
      service.updatePermissionForUserPerVehiculeForCust,
      data
    );
    const param = yield call(
      service.updateParamForUserPerVehiculeForCust,
      data
    );
  } catch (error) {
    yield put(actions.loadParamUserErrorAction(error));
  } finally {
    yield put(actions.loadParamUserFinishAction());
  }
}

function* updateParamCurrentUser(data) {
  try {
    yield put(actions.loadParamUserRequestAction());

    const param = yield call(
      service.updateParamForCurrentUserPerVehiculeForCust,
      data
    );
  } catch (error) {
    yield put(actions.loadParamUserErrorAction(error));
  } finally {
    yield put(actions.loadParamUserFinishAction());
  }
}

function* watchLoadParamUser() {
  yield takeEvery(types.LOAD_PARAM_USER, loadParamUser);
}

function* watchLoadParamCurrentUser() {
  yield takeLatest(types.LOAD_PARAM_FOR_CURRENT_USER, loadParamForCurrentUser);
}

function* watchUpdateParamUser() {
  yield takeEvery(types.UPDATE_PARAM_USER, updateParamUser);
}

function* watchUpdateParamCurrentUser() {
  yield takeEvery(types.UPDATE_PARAM_CURRENT_USER, updateParamCurrentUser);
}

export function* paramUserSaga() {
  yield all([
    watchLoadParamUser(),
    watchUpdateParamUser(),
    watchLoadParamCurrentUser(),
    watchUpdateParamCurrentUser(),
  ]);
}
